// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Label = require("./Label.bs.js");
let Tooltip = require("./Tooltip.bs.js");
let DateFns = require("date-fns");
let CalendarDate = require("../../../reason/common/types/CalendarDate.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let UnselectedUnionMemberError = require("../ErrorHandling/UnselectedUnionMemberError.bs.js");
let PropertyMlsLabel_propertyV5_graphql = require("../../../__generated__/PropertyMlsLabel_propertyV5_graphql.bs.js");

let convertFragment = PropertyMlsLabel_propertyV5_graphql.Internal.convertFragment;

function PropertyMlsLabel(props) {
  let match = RescriptRelay_Fragment.useFragment(PropertyMlsLabel_propertyV5_graphql.node, convertFragment, props.property);
  let mlsPlan = match.mlsPlan;
  let activeOnMlsSince = match.activeOnMlsSince;
  let pill;
  if (activeOnMlsSince !== undefined) {
    pill = [
      JsxRuntime.jsx(Label.Neutral.make, {
        text: "On MLS"
      }),
      `Went active in the MLS on ` + DateFns.format(CalendarDate.toLocalDate(Primitive_option.valFromOption(activeOnMlsSince)), "MMM d")
    ];
  } else {
    switch (mlsPlan.__typename) {
      case "AlreadyOnMls" :
        pill = undefined;
        break;
      case "ListOnMlsAsActive" :
        pill = [
          JsxRuntime.jsx(Label.Neutral.make, {
            text: `OFF-MLS till ` + DateFns.format(CalendarDate.toLocalDate(mlsPlan.onMlsAt), "MMM d"),
            variant: "light"
          }),
          undefined
        ];
        break;
      case "ListOnMlsAsComingSoon" :
        pill = [
          JsxRuntime.jsx(Label.Neutral.make, {
            text: "MLS coming soon",
            variant: "light"
          }),
          `Planned to go active in the MLS on ` + DateFns.format(CalendarDate.toLocalDate(mlsPlan.activeOnMlsOn), "MMM d")
        ];
        break;
      case "NoMlsPlan" :
        pill = [
          JsxRuntime.jsx(Label.Neutral.make, {
            text: "OFF-MLS",
            variant: "light"
          }),
          undefined
        ];
        break;
      case "__unselected" :
        pill = UnselectedUnionMemberError.raise(`Unselected MLS plan ` + mlsPlan._0);
        break;
    }
  }
  if (pill === undefined) {
    return null;
  }
  let tooltip = pill[1];
  let label = pill[0];
  if (tooltip !== undefined) {
    return JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx(Tooltip.make, {
        label: tooltip,
        children: JsxRuntime.jsx("span", {
          children: label
        })
      }),
      className: "z-10 relative cursor-default"
    });
  } else {
    return JsxRuntime.jsx("div", {
      children: label
    });
  }
}

let make = PropertyMlsLabel;

exports.make = make;
/* Label Not a pure module */
